:host {
  --label-color: var(--stzh-checkbox-label-color, #{$baseColor});
  --label-hover-color: var(
    --stzh-checkbox-label-hover-color,
    #{$colorPrimary70}
  );
  --label-hover-checked-color: var(
    --stzh-checkbox-label-hover-checked-color,
    #{$colorPrimary90}
  );
  --check-color: var(--stzh-checkbox-check-color, #{$colorPrimary});
  --invalid-color: var(--stzh-checkbox-invalid-color, #{$colorError60});
  --disabled-color: var(--stzh-checkbox-disabled-color, #{$colorGrey50});

  display: inline-block;

  &[disabled]:not([disabled="false"]) {
    --description-color: #{$formDisabledColor};
  }
}

.stzh-checkbox {
  @include input-description;
  display: grid;

  &__field-wrapper {
    @include fontSize("milli");
    position: relative;
    display: flex;
    user-select: none;
    cursor: pointer;
  }

  &__input {
    @include visuallyhiddenInput;
    border-radius: $formInputBorderRadius;
  }

  &__mark {
    border: 2px solid $colorBlack;
    background-color: $colorWhite;
    width: 24px;
    height: 24px;
    flex-shrink: 0;
    border-radius: $formInputBorderRadius;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    transition: border-color $baseTransitionAnimationSpeed;
    position: relative;
  }

  &__check {
    display: block;
    position: absolute;
    top: 50%;
    left: 50%;
    width: 100%;
    height: 100%;
    transform: translate(-50%, -50%) translateZ(0);
    will-change: opacity;
    opacity: 0;
    transition: opacity 0.15s ease;
    pointer-events: none;

    -webkit-mask-image: svg-load("stzh-checkbox/assets/check.svg");
    mask-image: svg-load("stzh-checkbox/assets/check.svg");
    -webkit-mask-repeat: no-repeat;
    mask-repeat: no-repeat;
    -webkit-mask-position: center;
    mask-position: center;
    -webkit-mask-size: contain;
    mask-size: contain;

    background-color: var(--check-color);
  }

  &__label {
    --stzh-base-color: initial;

    display: inline-block;
    color: var(--label-color);
    transition: color $baseTransitionAnimationSpeed;
    margin-left: space("small");
    line-height: 24px;

    &:empty {
      display: none;
    }
  }

  &__marker {
    @include fontSize("micro");
    margin-left: calc(-0.25em + #{space("xsmall")});
  }

  /* Hover / Focus / Checked */

  &:hover &__label,
  &__input:checked ~ &__label {
    color: var(--label-hover-color);
  }

  &__input:checked:hover ~ &__label,
  &__input:checked:hover ~ &__mark {
    color: var(--label-hover-checked-color);
  }

  // icon
  &__input:checked:hover ~ &__mark .stzh-checkbox__check {
    background-color: var(--label-hover-checked-color);
  }

  &:hover &__mark,
  &__input:checked ~ &__mark {
    border-color: var(--label-hover-color);
  }

  &__input:checked:hover ~ &__mark {
    border-color: var(--label-hover-checked-color);
  }

  &--is-checked .stzh-checkbox__check {
    opacity: 1;
  }

  /* Invalid */

  &--is-invalid &__input ~ &__label,
  &--is-invalid &__input ~ &__mark {
    color: var(--invalid-color);
  }

  // icon
  &--is-invalid &__check {
    background-color: var(--invalid-color);
  }

  &--is-invalid &__input ~ &__mark {
    border-color: var(--invalid-color);
  }

  /* Disabled */

  &--is-disabled &__field-wrapper {
    cursor: not-allowed;
  }

  &--is-disabled &__input ~ &__label {
    color: $colorGrey60;
  }

  &--is-disabled &__input ~ &__mark {
    color: var(--disabled-color);
    border-color: var(--disabled-color);
  }

  // icon
  &--is-disabled &__check {
    background-color: var(--disabled-color);
  }

  &--is-disabled &__mark {
    background-color: $colorGrey20;
  }

  // hover styles for check icon for invalid
  &--is-invalid &__input:checked:hover ~ &__mark .stzh-checkbox__check {
    background-color: var(--invalid-color);
  }

  // hover styles for check icon for invalid
  &--is-disabled &__input:checked:hover ~ &__mark .stzh-checkbox__check {
    background-color: var(--disabled-color);
  }
}
